import { MUITab } from "@abb/arcadia-ui-react"
import { useCallback, useContext, useEffect, useState } from "react"
import {
  DiMaDetailsHeader,
  DiMaDetailsHeaderProps,
} from "../../components/DiMaDetailsHeader"
import { DiMaProgress } from "../../components/DiMaProgress"
import { UserContext } from "../../context/UserContext"
import {
  AccessLevel,
  DimaFeatureShortNameEnum,
  hasUserAccessToFeature,
} from "../../models/Authorization"
import { EmailSettings } from "./email_settings_tab/EmailSettings"

const EMAIL_SETTINGS_TAB_ID = "email-settings"

export function SettingsContainer() {
  const { user } = useContext(UserContext)
  const returnURL = `/`
  const [activeTab, setActiveTab] = useState(EMAIL_SETTINGS_TAB_ID)
  const handleTabChange = useCallback((id: string) => setActiveTab(id), [])

  const userHasEmailSettingsAccess = hasUserAccessToFeature(
    user?.authorizations ?? { applications: [], features: [] },
    DimaFeatureShortNameEnum.RR,
    AccessLevel.Read
  )

  useEffect(() => {
    if (!userHasEmailSettingsAccess) {
      setActiveTab(EMAIL_SETTINGS_TAB_ID)
    }
  }, [userHasEmailSettingsAccess])

  if (!user) {
    return <DiMaProgress />
  }

  const detailsHeaderProps: DiMaDetailsHeaderProps = {
    url: returnURL,
    title: user.first && user.last ? `${user.first} ${user.last}` : "No name available",
    label: "User ID",
    subtitle: user.id,
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
      <DiMaDetailsHeader {...detailsHeaderProps} />

      <MUITab
        tabItems={
          userHasEmailSettingsAccess
            ? [{ id: EMAIL_SETTINGS_TAB_ID, label: "Email Settings" }]
            : []
        }
        value={activeTab}
        handleChange={handleTabChange}
      />

      {userHasEmailSettingsAccess && activeTab === EMAIL_SETTINGS_TAB_ID && (
        <EmailSettings />
      )}
    </div>
  )
}
